import React from 'react';
import { CountdownBar } from '../components/CountdownBar';
import { Hero } from '../components/Hero';
import { PainPoints } from '../components/PainPoints';
import { Reframe } from '../components/Reframe';
import { InsideCarousel } from '../components/InsideCarousel';
import { ProductIntro } from '../components/ProductIntro';
import { Benefits } from '../components/Benefits';
import { Bonuses } from '../components/Bonuses';
import { Inclusions } from '../components/Inclusions';
import { OfferCard } from '../components/OfferCard';
import { Testimonials } from '../components/Testimonials';
import { Guarantee } from '../components/Guarantee';
import { HelpVideo } from '../components/HelpVideo';
import { Faq } from '../components/Faq';
import { PurchaseToast } from '../components/PurchaseToast';
import { Sparkle } from '../components/Sparkle';
type LandingProps = {
  showPurchaseToast: boolean;
};
export function Landing({
  showPurchaseToast
}: LandingProps) {
  return <div className="min-h-screen w-full bg-paper text-ink" data-id="element-185" data-mp="2a0ig2bxce55">
      <CountdownBar data-id="element-186" data-mp="2bboy9wr7zzy" />
      <Hero data-id="element-187" data-mp="27nv19nedbkp" />
      <main data-id="element-188" data-mp="3tgbj3xd0vcvy">
        <PainPoints data-id="element-189" data-mp="3tftof560d6q5" />
        <Reframe data-id="element-190" data-mp="3tfa1tb5exu5s" />
        <InsideCarousel data-id="element-191" data-mp="3tes1a2bpwts2" />
        <ProductIntro data-id="element-192" data-mp="3tio82uh76nii" />
        <Benefits data-id="element-193" data-mp="3pegjcxaqp7ka" />
        <Bonuses data-id="element-194" data-mp="3pdyejca0hl0r" />
        <Inclusions data-id="element-195" data-mp="3pfj9h308n5z5" />
        <OfferCard id="oferta" data-id="element-196" data-mp="3pgua4tydzxm1" />
        <Testimonials data-id="element-197" data-mp="3kfwtilt0zbmn" />
        <Guarantee data-id="element-198" data-mp="3kgopvyug5ddz" />
        <OfferCard data-id="element-199" data-mp="3kh7vqh6tobbn" />
        <HelpVideo data-id="element-200" data-mp="3khq3a9yxqbyv" />
        <Faq data-id="element-201" data-mp="l0i8u09aaxnc" />
      </main>
      <footer className="border-t-2 border-ink bg-ink py-8 text-center text-sm text-kraft-light" data-id="element-202" data-mp="l0rsl63qk8kl">
        <p className="flex items-center justify-center gap-2 font-display font-bold text-cream" data-id="element-203" data-mp="gyoee9pompvm">
          <Sparkle className="h-3 w-3" data-id="element-204" data-mp="c7enz6wb7iio" /> Diario de Prioridad <Sparkle className="h-3 w-3" data-id="element-205" data-mp="c63ldaelogt5" />
        </p>
        <p className="mt-2" data-id="element-206" data-mp="79wmu2oja7l8">© {new Date().getFullYear()} · Producto digital en PDF</p>
      </footer>
      {showPurchaseToast && <PurchaseToast data-id="element-207" data-mp="14q26qfnu2lgl" />}
    </div>;
}